import { match as lang } from "../../../src/params/lang.ts";

export const matchers = { lang };